import React from 'react'

import Svg, { Line } from 'react-native-svg'

const DashedBorder = ({
  width = '100%',
  color = '#D1D9E9',
  strokeWidth = 2,
  dashWidth = 6,
  dashGap = 4,
}) => (
  <Svg height={strokeWidth} width={width}>
    <Line
      x1="0"
      y1={strokeWidth / 2}
      x2="100%"
      y2={strokeWidth / 2}
      stroke={color}
      strokeWidth={strokeWidth}
      strokeDasharray={[dashWidth, dashGap]}
    />
  </Svg>
)
export default DashedBorder
